import { render, staticRenderFns } from "./TimedGoodsItem.vue?vue&type=template&id=b2c03f06"
import script from "./TimedGoodsItem.vue?vue&type=script&lang=js"
export * from "./TimedGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./TimedGoodsItem.vue?vue&type=style&index=0&id=b2c03f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports